import { Box, Divider, FormControlLabel, Grid, IconButton, SelectChangeEvent, Switch, TextField, useMediaQuery, useTheme } from '@mui/material';
import ReactInputMask from 'react-input-mask';
import { IOrganization } from '../../../services/api/organization/OrganizationServices';
import { Search } from '@mui/icons-material';
import { VSelectCompany, VSelectDatum } from '../../shared';
import { useAuthContext } from '../../../context';

interface OrganizationFormsProps {
    data: IOrganization
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    fetchAdress: () => void;
    error: boolean;
    newForm: boolean;
    handleSwitchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeSelect: (event: SelectChangeEvent) => void;
    handleChangeDatum: (event: SelectChangeEvent) => void;
}

export const OrganizationForm = ({ data, handleChange, fetchAdress, error, newForm, handleSwitchChange, handleChangeSelect, handleChangeDatum }: OrganizationFormsProps) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const { userData } = useAuthContext();

    const requiredErrorText = 'É necessário preencher este campo';

    return (
        <>
            <Grid container spacing={1} padding={1}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Razão social'
                        type='text'
                        fullWidth
                        name='razao_social'
                        value={data?.razao_social || ''} 
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        error={error && data.razao_social === ''}
                        helperText={error && data.razao_social === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Nome fantasia'
                        type='text'
                        value={data?.nome_fantasia || ''}
                        fullWidth
                        name='nome_fantasia'
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        error={error && data.nome_fantasia === ''}
                        helperText={error && data.nome_fantasia === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <ReactInputMask
                        mask={'99.999.999/9999-99'}
                        value={data?.registro || ''}
                        name='registro'
                        onChange={handleChange}
                    >
                        {() =>
                            <TextField
                                label='CNPJ'
                                type='text'
                                fullWidth
                                name='registro'
                                InputLabelProps={{ shrink: true }}
                                error={error && data.registro === ''}
                                helperText={error && data.registro === '' ? requiredErrorText : null}
                                required
                            />
                        }
                    </ReactInputMask>
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='E-mail'
                        type='email'
                        name='email_geral'
                        placeholder='email@exemplo.com'
                        fullWidth
                        value={data?.email_geral || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <ReactInputMask
                        mask={'(99)99999-9999'}
                        value={data?.telefone_geral || ''}
                        name='telefone_geral'
                        onChange={handleChange}
                    >
                        {() =>
                            <TextField
                                label='Telefone'
                                type='text'
                                name='telefone_geral'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                error={error && data.telefone_geral === ''}
                                helperText={error && data.telefone_geral === '' ? requiredErrorText : null}
                                required
                            />
                        }
                    </ReactInputMask>
                </Grid>
                <Grid item xs={smDown ? 12 : 6} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    {newForm ?
                        null
                        :
                        <FormControlLabel
                            control={
                                <Switch
                                    name="ativo"
                                    checked={data.status || false} 
                                    onChange={handleSwitchChange}
                                />
                            }
                            label={'Ativo'}
                        />
                    }
                </Grid>
                {userData.nivel === 'adm' ?
                    <Grid item xs={smDown ? 12 : 6}>
                        <VSelectCompany
                            handleChangeSelect={handleChangeSelect}
                            initValue={data.id_empresa || ''} 
                            required
                        />
                    </Grid> : null
                }
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Unidade operacional'
                        type='text'
                        name='unidade_operacional'
                        fullWidth
                        value={data?.unidade_operacional || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        error={error && data.unidade_operacional === ''}
                        helperText={error && data.unidade_operacional === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Atividade Principal'
                        type='text'
                        value={data?.atividade_principal || ''}
                        fullWidth
                        name='atividade_principal'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.atividade_principal === ''}
                        helperText={error && data.atividade_principal === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Produto'
                        type='text'
                        value={data?.produto || ''}
                        fullWidth
                        name='produto'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.produto === ''}
                        helperText={error && data.produto === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Produção anual'
                        type='number'
                        value={data?.producao_anual === undefined ? '' : data.producao_anual}
                        fullWidth
                        name='producao_anual'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Quantidade de empregados'
                        type='number'
                        value={data?.qtd_empregados === undefined ? '' : data.qtd_empregados} 
                        fullWidth
                        name='qtd_empregados'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Site'
                        type='text'
                        fullWidth
                        placeholder='exemplo.com.br'
                        name='site'
                        value={data?.site || ''}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Descrição de acesso'
                        type='text'
                        value={data?.descricao_acesso || ''}
                        fullWidth
                        name='descricao_acesso'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                    >
                        <ReactInputMask
                            mask={'99999-999'} 
                            value={data?.cep || ''}
                            name='cep'
                            onChange={handleChange}
                        >
                            {() =>
                                <TextField
                                    label='CEP'
                                    type='text'
                                    fullWidth
                                    name='cep'
                                    InputLabelProps={{ shrink: true }}
                                    error={error && data.cep === ''}
                                    helperText={error && data.cep === '' ? requiredErrorText : null}
                                    required
                                />
                            }
                        </ReactInputMask>
                        <IconButton
                            onClick={fetchAdress}
                            disabled={!data.cep || data.cep.replace(/\D/g, '').length !== 8} 
                        >
                            <Search />
                        </IconButton>
                    </Box>
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Rua'
                        type='text'
                        value={data?.rua || ''}
                        fullWidth
                        name='rua'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Bairro'
                        type='text'
                        value={data?.bairro || ''}
                        fullWidth
                        name='bairro'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Número'
                        type='text'
                        value={data?.numero || ''}
                        fullWidth
                        name='numero'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Complemento'
                        type='text'
                        value={data?.complemento || ''}
                        fullWidth
                        name='complemento'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Cidade'
                        type='text'
                        value={data?.cidade || ''}
                        fullWidth
                        name='cidade'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.cidade === ''}
                        helperText={error && data.cidade === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Estado'
                        type='text'
                        value={data?.estado || ''}
                        fullWidth
                        name='estado'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.estado === ''}
                        helperText={error && data.estado === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='País'
                        type='text'
                        value={data?.pais || ''}
                        fullWidth
                        name='pais'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.pais === ''}
                        helperText={error && data.pais === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <VSelectDatum
                        handleChangeSelect={handleChangeDatum}
                        initValue={data.datum || ''}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Zona Fuso'
                        type='number'
                        name='fuso_zona'
                        value={data?.fuso_zona === undefined ? '' : data.fuso_zona} 
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        error={error && (data.fuso_zona === undefined || data.fuso_zona === null)}
                        helperText={error && (data.fuso_zona === undefined || data.fuso_zona === null) ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Hemisférios'
                        type='text'
                        name='hemisferio'
                        fullWidth
                        value={data?.hemisferio || ''}
                        InputLabelProps={{ shrink: true }}
                        error={error && data.hemisferio === ''}
                        helperText={error && data.hemisferio === '' ? requiredErrorText : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <ReactInputMask
                        mask={'9999999.99'}
                        value={data?.utm_ns === undefined ? '' : String(data.utm_ns)} 
                        name='utm_ns'
                        onChange={handleChange}
                    >
                        {() =>
                            <TextField
                                label='UTM NS'
                                type='text' 
                                fullWidth
                                name='utm_ns'
                                InputLabelProps={{ shrink: true }}
                                error={error && (data.utm_ns === undefined || data.utm_ns === null)}
                                helperText={error && (data.utm_ns === undefined || data.utm_ns === null) ? requiredErrorText : null}
                                required
                            />
                        }
                    </ReactInputMask>
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <ReactInputMask
                        mask={'999999.99'}
                        value={data?.utm_ew === undefined ? '' : String(data.utm_ew)} 
                        name='utm_ew'
                        onChange={handleChange}
                    >
                        {() =>
                            <TextField
                                label='UTM EW'
                                type='text' 
                                fullWidth
                                name='utm_ew'
                                InputLabelProps={{ shrink: true }}
                                error={error && (data.utm_ew === undefined || data.utm_ew === null)}
                                helperText={error && (data.utm_ew === undefined || data.utm_ew === null) ? requiredErrorText : null}
                                required
                            />
                        }
                    </ReactInputMask>
                </Grid>
            </Grid>
        </>
    );
};